import type {ISceneManager} from "#template/interfaces/scene-manager"
import type {Inlet, Outlet} from "#template/runtime-graph/slots"
import {NotReady} from "#template/runtime-graph/slots"
import {TypeDescriptors} from "#template/runtime-graph/type-descriptors"
import type {NodeClassImpl} from "#template/runtime-graph/types"
import type {DataObjectWithRelated} from "@cm/utils"
import type {Subscription} from "rxjs"
import {defer, map} from "rxjs"

const TD = TypeDescriptors

const loadDataDescriptor = {
    sceneManager: TD.inlet(TD.Identity<ISceneManager>()),
    dataObject: TD.inlet(TD.DataObject),
    data: TD.outlet(TD.Identity<Uint8Array>()),
}

export class LoadData implements NodeClassImpl<typeof loadDataDescriptor, typeof LoadData> {
    static descriptor = loadDataDescriptor
    static uniqueName = "LoadData"
    sceneManager!: Inlet<ISceneManager>
    dataObject!: Inlet<DataObjectWithRelated>
    data!: Outlet<Uint8Array>

    private pending: Subscription | null = null

    run() {
        this.cleanup()

        if (this.sceneManager === NotReady || this.dataObject === NotReady) {
            this.data.emitIfChanged(NotReady)
            return
        }

        const {dataObject, sceneManager} = this

        this.pending = sceneManager.addTask({
            description: `loadData(${dataObject.legacyId})`,
            task: defer(() => sceneManager.loadDataObjectContent(dataObject)).pipe(
                map((data) => {
                    this.data.emitIfChanged(data)
                }),
            ),
            critical: true,
        })
    }

    cleanup() {
        this.pending?.unsubscribe()
        this.pending = null
    }
}
